import { IApiEpBillingBill } from "@smp/api";
import { UiBox } from "@smp/ui";
import { useCallback, useEffect } from "react";

import { useYakassa } from "@/hooks/use_yakassa";

export const Yakassa = ({
  bill,
  onClose,
  redirectDisabled,
}: {
  bill: IApiEpBillingBill;
  onClose: (fireSuccessAction?: boolean) => void;
  redirectDisabled?: boolean;
}) => {
  const urlOrigin = window.location.origin;
  const urlSuccess =
    urlOrigin + "/home/public/purchase/success?bill=" + bill.id;

  const { destroy, isLoaded, on, render } = useYakassa({
    confirmation_token: bill.extra.yoomoney_confirmation_token || "",
    error_callback: (error) => console.log(error),
    return_url: !redirectDisabled ? urlSuccess : undefined,
  });

  const tabIndexesAndElements = Array.from(
    document.querySelectorAll("[role] [tabindex]"),
  ).map((node) => ({ node: node, tabIndex: node.getAttribute("tabindex") }));

  const removeTabIndexes = useCallback(() => {
    tabIndexesAndElements?.forEach(({ node }) => {
      node.removeAttribute("tabindex");
    });
  }, [tabIndexesAndElements]);

  const returnTabIndexes = useCallback(() => {
    tabIndexesAndElements?.forEach(({ node, tabIndex }) => {
      tabIndex && node.setAttribute("tabindex", tabIndex);
    });
  }, [tabIndexesAndElements]);

  useEffect(() => {
    if (!isLoaded) {
      return;
    }

    removeTabIndexes();

    on("complete", () => {
      onClose(true);
      returnTabIndexes();
      destroy();
    });

    on("fail", () => {
      returnTabIndexes();
    });

    on("success", () => {
      returnTabIndexes();
    });

    render("yoo_money_widget");
  }, [
    destroy,
    isLoaded,
    on,
    render,
    removeTabIndexes,
    returnTabIndexes,
    onClose,
  ]);

  return <UiBox id="yoo_money_widget" />;
};
